export default __webpack_public_path__ + "static/media/BB_12.a54a6713.png";